import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
// import withStyles from "@material-ui/core/styles/withStyles";
import "./styles.css";
import "animate.css/animate.css";
import VIrus from "../../images/VIrus.svg"
const EvaluatorModal = ({
  classes,
  handleReloadClick
}) => {
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh", justifyContent: "center" }}
      >
        <Grid className="evaluatorModalContainer">
          <img src={VIrus} alt="" style={{ height: 100 }}/>
          {/* <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "Fiscal Policy is <i>very</i> hard to get right!" }} /> */}
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "Measles, mumps, and rubella are all highly contagious diseases. Measles alone infects an estimated 90% of unvaccinated individuals who have contact with an infected person." }}>
          </Typography>
          {/* <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "Here’s how the slot machine works: the first reel is the downturn cause, the second reel is the policy and the third reel is the details of the implementation." }}>
          </Typography>
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "You have to nail all three for Fiscal Policy to revive the economy." }}>
          </Typography> */}
          {/* <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "So, ready? See if you “Keynes” can hit the fiscal policy jackpot!" }}>
          </Typography> */}
          <Grid container style={{ justifyContent: "center" }}>
            <Button className="submitButton" onClick={() => handleReloadClick()}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EvaluatorModal;
